export const productName = import.meta.env.VITE_PRODUCT_NAME ?? "Popdock";
export const productSlug = import.meta.env.VITE_PRODUCT_SLUG ?? "popdock";
